<main class="blog-page">
  <!-- HERO -->
  <section class="page-hero">
    <div class="container-xl pt-navfix">
      <div class="hero-card card-sami">
        <div class="row align-items-center g-4">
          <div class="col-12 col-lg-7">
            <h1 class="fw-bold mb-2">Blog SAMI Pulizie</h1>
            <p class="mb-0 hero-sub">
              Guide, consigli e approfondimenti su pulizie professionali,
              sanificazioni e buone pratiche per casa, uffici e condomini a
              Pescara.
            </p>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <a class="btn-sami" [routerLink]="['/preventivo']">Richiedi un preventivo</a>
              <a class="btn-sami-outline" href="tel:08554360">Chiama 085 54360</a>
            </div>

            <!-- SEARCH + FILTER -->
            <div class="filters mt-4">
              <div class="search">
                <i class="fa-solid fa-magnifying-glass"></i>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Cerca un articolo (es. sanificazione, costi, casa...)"
                  [(ngModel)]="query"
                  (input)="applyFilters()"
                />
              </div>

              <select
                class="form-select"
                [(ngModel)]="category"
                (change)="applyFilters()"
              >
                <option value="Tutti">Tutte le categorie</option>
                <option *ngFor="let c of categories" [value]="c">
                  {{ c }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12 col-lg-5">
            <div class="hero-media">
              <img
                src="assets/quanto-costa-la-pulizia.webp"
                class="hero-img"
                alt="Blog pulizie e sanificazioni a Pescara - SAMI Pulizie"
                loading="eager"
                fetchpriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- GRID POST -->
  <section class="section">
    <div class="container-xl">
      <div class="section-head">
        <h2 class="fw-bold mb-1">Ultimi articoli</h2>
        <p class="text-muted mb-0">
          Se vuoi un sopralluogo gratuito, vai su
          <a [routerLink]="['/preventivo']">Preventivo</a>.
        </p>
      </div>

      <div class="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3 mt-2">
        <div class="col" *ngFor="let post of filteredPosts">
          <article class="post-card card-sami h-100">
            <div class="post-cover">
              <!-- ✅ immagine cliccabile solo se pubblicato -->
              <a
                *ngIf="post.published"
                class="cover-link"
                [routerLink]="['/blog', post.slug]"
                [attr.aria-label]="'Apri articolo: ' + post.title"
                [title]="post.title"
              >
                <img
                  [src]="post.img"
                  [alt]="post.title"
                  loading="lazy"
                  decoding="async"
                />
              </a>

              <img
                *ngIf="!post.published"
                [src]="post.img"
                [alt]="post.title"
                loading="lazy"
                decoding="async"
              />

              <span class="badge-cat">{{ post.category }}</span>
            </div>

            <div class="p-3">
              <!-- ✅ titolo cliccabile se pubblicato -->
              <h3 class="post-title" *ngIf="post.published">
                <a
                  class="post-title-link"
                  [routerLink]="['/blog', post.slug]"
                  [attr.aria-label]="'Leggi articolo: ' + post.title"
                >
                  {{ post.title }}
                </a>
              </h3>

              <h3 class="post-title" *ngIf="!post.published">
                {{ post.title }}
              </h3>

              <div class="post-meta">
                <span>
                  <i class="fa-regular fa-calendar"></i> {{ post.date }}
                </span>
                <span class="dot">•</span>
                <span>
                  <i class="fa-regular fa-clock"></i> {{ post.readingTime }}
                </span>
              </div>

              <p class="post-excerpt mb-0">{{ post.excerpt }}</p>

              <div class="mt-3">
                <!-- ✅ bottone articolo: link se pubblicato, disabled se in arrivo -->
                <a
                  class="btn-sami w-100"
                  *ngIf="post.published"
                  [routerLink]="['/blog', post.slug]"
                  [attr.aria-label]="'Leggi l’articolo ' + post.title"
                >
                  Leggi l’articolo
                </a>

                <button
                  class="btn-sami w-100"
                  *ngIf="!post.published"
                  disabled
                  aria-disabled="true"
                  title="Articolo in arrivo"
                >
                  Articolo (in arrivo)
                </button>
              </div>
            </div>
          </article>
        </div>
      </div>

      <!-- EMPTY -->
      <div class="empty card-sami mt-4" *ngIf="filteredPosts.length === 0">
        <div class="empty-inner">
          <i class="fa-solid fa-circle-info"></i>
          <div>
            <div class="fw-bold">Nessun risultato</div>
            <div class="text-muted">
              Prova a cambiare categoria o a cercare un’altra parola.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="section-cta cta-wide">
    <div class="container-xl text-center">
      <h2 class="cta-title">Vuoi un sopralluogo gratuito?</h2>
      <p class="cta-text">
        Ti rispondiamo rapidamente con un preventivo personalizzato per casa,
        uffici, condomini e sanificazioni.
      </p>

      <div class="mt-3">
        <a class="btn btn-light cta-btn w-100" href="tel:08554360">
          Chiama ora
        </a>
      </div>
    </div>
  </section>
</main>
